import { defineStyleConfig } from '@chakra-ui/react';
import type { StyleFunctionProps } from '@chakra-ui/styled-system';

const Button = defineStyleConfig({
    baseStyle: {
        fontWeight: '700',
        borderWidth: 1,
        borderRadius: 8,
    },
    sizes: {
        sm: {
            h: '38px',
            fontSize: '12px',
            lineHeight: '18px',
            px: '37px',
        },
        md: {
            h: '50px',
            fontSize: '14px',
            lineHeight: '21px',
            px: '37px',
        },
    },
    variants: {
        primary: (props: StyleFunctionProps) => ({
            bg: 'primary',
            color: 'black',
            fontSize: '16px',
            borderColor:
                props.colorMode === 'light' ? 'transparent' : 'midnightBlue',
            _hover: {
                bg: 'secondary',
            },
            _disabled: {
                pointerEvents: 'none',
                bg: "primary !important"
            },
        }),
        secondary: {
            bg: 'secondary',
            borderColor: 'transparent',
            fontSize: '16px',
            lineHeight: '28px',
            color: 'black',
            _hover: {
                bg: 'primary',
            },
            _disabled: {
                pointerEvents: 'none',
                bg: "secondary !important"
            },
        },
        tertiary: {
            bg: 'red',
            borderColor: 'transparent',
            fontSize: '16px',
            lineHeight: '28px',
            color: 'black',
            _disabled: {
                pointerEvents: 'none',
                bg: "red !important"
            },
        },
        link: (props: StyleFunctionProps) => ({
            borderWidth: 0,
            borderRadius: 0,
            fontSize: '16px',
            fontWeight: '400',
            lineHeight: '28px',
            textDecoration: 'underline',
            color: props.colorMode === 'light' ? 'midnightBlue' : 'skyBlue',
            _disabled: {
                pointerEvents: 'none',
            },
        }),
        icon: {
            w: '24px',
            h: '24px',
            minW: '24px',
            maxW: '24px',
            p: 0,
            fontSize: '24px',
            border: 'none',
            borderRadius: 0,
        },
    },
    defaultProps: {
        variant: 'primary',
    },
});
export default Button;
